// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__2Mo5u","primary":"Button_primary__1mTxz Button_container__2Mo5u","accent":"Button_accent__1Odu5 Button_container__2Mo5u"};